module.exports = __webpack_public_path__ + "img/norcott_b3.724e6f92.jpg";